







request = require "superagent"
FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	props: ["post"]
	computed:
		isEnglish: -> return FUNCTIONS.judgeIsEnglish(this.$route)
		date: -> WP.date(this.post)
		excerpt: -> WP.excerpt(this.post)
		isNew: -> WP.isNew(this.post)
		to: ->
			if this.isEnglish then return {name: "en_publication", params: {id: this.post.id, page: 1}}
			return {name: "publication", params: {id: this.post.id, page: 1}}
	methods:
		renderText: (ja, en) -> return if !this.isEnglish then ja else en




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/archive/publications/postLink.vue